import { useHistory } from 'react-router-dom';
import { useState, useEffect, useContext } from 'react';
import User from 'services/user2';
import Util from '../lib/util';

/* dev
http://open.weixin.qq.com/connect/oauth2/authorize?appid=wxf3cf604fbe16e419&redirect_uri=https%3A%2F%2Fdev.xiekeyun.com%2Fmp%2Fkchat&response_type=code&scope=snsapi_base&state=123#wechat_redirect
*/

function KChat() {
  const history = useHistory();

  const [isInit, setIsInit] = useState(false);

  useEffect(() => {
    init();
  });

  function init() {
    if (isInit) {
      return;
    }
    setIsInit(true);

    //环信网页跳转方式不支持传访客信息
    // //window.location.href =
    //   'https://kefu.easemob.com/webim/im.html?configId=717ce51f-8225-46cd-af1e-9e3b2a12028b';

      window.location.href = 'https://im5fa212f.7x24cc.com/phone_webChat.html?accountId=N000000037667&chatId=4f44ffaf-bddd-45b5-9153-4be893d00038';

    // try {
    //   User.init(undefined).then(response => {
    //     if (response.success) {
    //       //let defaultCompany = User.getDefaultCompany() || {};
    //       //let userInfo: any = User.getUserInfo() || {};
    //       // if (defaultCompany) {
    //       //   let params = {
    //       //     name: userInfo.nickName,
    //       //     email: userInfo.email,
    //       //     phone: userInfo.mobile,
    //       //     //自定义用户信息
    //       //     metadata: JSON.stringify([
    //       //       { name: '公司编码', value: defaultCompany.companyCode },
    //       //       { name: '公司名称', value: defaultCompany.companyName },
    //       //       { name: '用户岗位', value: defaultCompany.roleName }
    //       //     ]),
    //       //     custom_data: JSON.stringify([
    //       //       { name: 'field_1001659', value: userInfo.mobileArea },
    //       //       { name: 'field_1001672', value: defaultCompany.companyCode },
    //       //       { name: 'field_1001661', value: defaultCompany.companyName }
    //       //     ])
    //       //   };

    //       //   let url = encodeURI(
    //       //     Util.addParams('https://xieke.kf5.com/kchat/1039821', params)
    //       //   );
    //       // }

    //       //环信网页跳转方式不支持传访客信息
    //       window.location.href =
    //         'https://kefu.easemob.com/webim/im.html?configId=717ce51f-8225-46cd-af1e-9e3b2a12028b';
    //     } else {
    //       history.push('/mp/index');
    //     }
    //   });
    // } catch (e: any) {
    //   if (navigator.sendBeacon) {
    //     let postbody = {
    //       error: e.stack
    //     };
    //     navigator.sendBeacon('/api/jsError', JSON.stringify(postbody));
    //   }
    // }
  }

  return '';
}

export default KChat;
